<template>
    <b-modal :no-close-on-backdrop="true" :title="$t('create_new_customer')" ref="innermodal">
        <div v-if="$v.$error" class="alert alert-danger x-error">
            <div class="error" v-if="!$v.model.Name.required">- សូមធ្វើការបញ្ជូលឈ្មោះចំណូល</div>
            <div class="error" v-if="!$v.model.Phone.required">- សូមធ្វើការបញ្ជូលលេខទូរសព្ទ</div>
        </div>
        <div class="form-group" :class="{ 'form-group-error': $v.model.Name.$error }">
            <label class="blue label-control">{{$t('name')}}</label>
            <div><input type="text" class="form-control form-control-sm" v-model="$v.model.Name.$model" /></div>
        </div>
        <div class="form-group" :class="{ 'form-group-error': $v.model.Phone.$error }">
            <label class="blue label-control">{{$t('phone')}}</label>
            <div><input type="text" class="form-control form-control-sm" v-model="$v.model.Phone.$model" /></div>
        </div>
        <div class="form-group">
            <label class="blue label-control">{{$t('email')}}</label>
            <div><input type="text" class="form-control form-control-sm" v-model="model.Email" /></div>
        </div>
        <div class="form-group">
            <label class="blue label-control">{{$t('website')}}</label>
            <div><input type="text" class="form-control form-control-sm" v-model="model.Website" /></div>
        </div>
        <div class="form-group">
            <label class="blue label-control">{{$t('address')}}</label>
            <div><input type="text" class="form-control form-control-sm" v-model="model.Address" /></div>
        </div>
        <div slot="modal-footer">
            <b-btn variant="primary" size="sm" @click="clickSaveHandler"><i class="fa fa-floppy-o" aria-hidden="true"></i> {{$t('save')}}</b-btn>
        </div>
    </b-modal>
</template>
<script>
import { required } from 'vuelidate/lib/validators'
export default {
    props: {
        value: {
            type: Object,
            default: undefined
        },
        link: {
            type: String,
            default: 'customer/save'
        }
    },
    data: function() {
        return {
            model: {
                Name: '',
                Phone: ''
            },
            actionLink: this.link
        }
    },
    validations:{
        model: {
            Name: { required },
            Phone: { required }
        }
    },
    created: function(){
        if(this.value != undefined){
            this.model = this.value;
        }
    },
    methods: {
        clickSaveHandler: function() {
            this.$v.$touch();
            if (!this.$v.$invalid) {
                var loading = this.$loading.show();
                this.$api().post(this.actionLink, this.model).then(res => {
                    if(this.$isValid(res)){
                        var customer = res.data.Json.Customer;
                        this.$emit('done', customer);
                        this.$refs.innermodal.hide();
                    }
                }).finally(function() { loading.hide(); });
            }
        }
    },
    watch: {
        value(value){
            this.$v.$reset();
            if(value != undefined)
                this.model = value;
        },
        link(value){
            this.actionLink = value;
        }
    }
}
</script>
